const SuspenseFallback = ({ className }) => (
  <div className={`flex ${className} items-center justify-center`}>
    <span className='size-24 animate-spin rounded-full border-t-4 border-primary' />
  </div>
);

export default SuspenseFallback;
